



















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { EventBus, EventBusEvents } from "@/components/EventBus";

@Component
export default class Buttonmenu extends Vue {
  emitStartEvent() {
    EventBus.$emit(EventBusEvents.Start);
  }
  emitEvalGameEvent() {
    EventBus.$emit(EventBusEvents.EvaluateGame);
  }
}
